import { FC } from 'react'

import { Body, Image, Line } from './styles'

export const ProductGroupTileSkeleton: FC = () => {
  return (
    <Body>
      <Image />
      <Line />
      <Line width={'69%'} />
      <Line width={'20%'} />
    </Body>
  )
}
